// Webrtc plugin.
import * as actionTypes from '../actionTypes'

/**
 * Action creator
 * @method setBrowserDetails
 * @param  {Object} details
 * @param  {string} details.browser
 * @param  {number} details.version
 * @return {Object} A Flux-Standard-action.
 */
export function setBrowserDetails (details) {
  return {
    type: actionTypes.SET_BROWSER_DETAILS,
    payload: details
  }
}
